<template>
  <div class="table-wrapper">
    <table class="table-wrapper">
        <thead>
            <tr>
                <th class="text-center">{{ $t('Rank') }}</th>
                <th>{{ $t('Photo') }}</th>
                <th>{{ $t('Name') }}</th>
                <th>{{ $t('Points') }}</th>
                <th>{{ $t('Time') }}</th>
            </tr>
        </thead>
      <tbody>
        <tr v-for="(item, index) in getLeaderboard" :key="index" :style="{ fontWeight: isLoggedIn && item.client_id == userInfo.id ? 'bold' : 'normal' }">
            <td style="text-align: center">
                <span v-if="index === 0" style="font-size: 42px">🥇</span>
                <span v-else-if="index === 1" style="font-size: 42px">🥈</span>
                <span v-else-if="index === 2" style="font-size: 42px">🥉</span>
                <span v-else v-text="item.rank"></span>
            </td>
            <td>
                <img
                  v-lazy="item.photo || 'https://via.placeholder.com/50'"
                  :alt="item.name"
                  style="
                    width: 50px;
                    height: 50px;
                    border-radius: 16px;
                    padding: 4px;
                  "
                />
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.play_seconds }}</td>
            <td>{{ item.play_time_formatted }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useHomeStore } from "@/store/home";
import { useAuthStore } from '@/store/auth'

export default {
  name: "LeaderboardComponent",
  data() {
    return {
      intervalId: null,
    };
  },
  computed: {
    ...mapState(useHomeStore, ["getLeaderboard"]),
    ...mapState(useAuthStore, ["isLoggedIn", "userInfo"]),
  },
  methods: {
    ...mapActions(useHomeStore, ["fetchLeaderboard"]),
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        // Resume polling when tab becomes visible
        this.startPolling();
        // Immediately fetch fresh data
        this.fetchLeaderboard();
      } else {
        // Pause polling when tab becomes hidden
        this.stopPolling();
      }
    },
    startPolling() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      // Poll every 30 seconds (reduced from 10s to decrease server load)
      this.intervalId = setInterval(async () => {
        await this.fetchLeaderboard();
      }, 30000);
    },
    stopPolling() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
  },
  async mounted() {
    await this.fetchLeaderboard();
    // Start polling with visibility API support
    this.startPolling();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeUnmount() {
    this.stopPolling();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
};
</script>
